<template>
	<div class="ts-w-full ts-h-full">
		<label>{{ $t('productRecipe.recipeAddOn') }}</label>
		<input
			v-model.trim="text_search" 
			type="text" class="form-control" 
			:placeholder="$t('search')"
		>
		    <small class="ts-mt-1">
      <i>{{$t('productRecipe.clickAddItem')}}</i>
    </small>

		<div class="ts-mt-3 ts-space-y-1 ts-p-3 max-h ts-overflow-scroll">
			<p
				v-for="(r, index) in recipeList"
				:key="index"
			>
				<a href="#" @click.prevent="addItem(r)">{{ r.pro_group_name +' - '+ r.product_name_en }}</a>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: ['value', 'list'],
	data() {
		return {
			text_search: '',
			model: {}
		}
	},
	created () {
		this.model = this.value;
	},
	computed: {
		recipeList: vm => {
			return vm.list.filter(p => !_.includes(vm.model.sale_code_id_list, p.pro_sale_code_id))
				.filter(p => vm.text_search.toLowerCase().split(' ').every(t => (p.pro_group_name_en +'-'+ p.product_name_en).toLowerCase().includes(t)))
		}
	},
	methods: {
		addItem(r) {
			this.model.sale_code_id_list.push(r.pro_sale_code_id)	
		}
	},
}
</script>

<style scoped>
	.max-h {
		max-height: 500px !important;
		overflow: scroll;
	}
</style>